/*
 * 
 * key
 * 
 */
const key = 'ZW1wbG95ZWVJbnN0YW50UmVxdWVzdA=='

export default key